import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import { NAV } from "@/constants/testIds";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <Button
      data-testid={NAV.themeToggle}
      variant="ghost"
      size="icon"
      onClick={toggle}
      className="rounded-full border border-border hover:border-primary/60"
      aria-label="Toggle theme"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
